import styled from "styled-components";

export const CMCard = styled.div(props => ({
    margin: '5px',
    height: '100%',
    borderRadius: 12,
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',

    '& > div': {
        padding: '1.25rem 1rem',
    },
}));

export const CMCardTitle = styled.div(props => ({
    position: 'relative',
    backgroundColor: props.theme.palette.gray["500"],

    '& > div': {
        display: 'flex',
        justifyContent: 'space-between',
    },

    'h4': {
        fontWeight: 500,
        marginTop: 0,
        letterSpacing: '-0.45px',
        marginBottom: props.theme.spacers["3"],
        fontFamily: props.theme.fontFamilies.workSans,
    },

    'span': {
        fontWeight: 400,
        bottom: props.theme.spacers["4"],
        position: 'absolute',
        fontSize: props.theme.fontSizes.caption,
        color: props.theme.palette.primary.main,
    },

    'svg': {
        width: 16,
        height: 16,
        marginTop: 5,
        display: 'none'
    },
}));

export const CMCardDescription= styled.div(props => ({
    '& > div': {
        display: 'flex',
        justifyContent: 'space-between',

        'p': {
            marginTop: 0,
            fontWeight: 400,
        },

        '&:last-of-type': {
            'p': {
                marginBottom: 0,
            }
        },

        '&.dotted-border': {
            marginBottom: '5px',
            paddingBottom: '5px'
        },
    }
}));